<template>
  <div class="container">
    <Header :present-page="presentPage" />
    <a-row class="top">
      <a-col class="ipt">
        <span>数据来源</span>
        <a-select
          class="a-select"
          ref="select"
          v-model:value="siteId"
          placeholder="请选择"
          @change="handleDataFrom"
        >
          <a-select-option
            v-for="item in dataFrom"
            :key='item'
            :value="item.value"
          >
            {{item.siteId}}
          </a-select-option>
        </a-select>
        <a-divider type="vertical" />
      </a-col>
      <a-col class="ipt">
        <span>设备id</span>
        <a-select
          v-if="siteId == 0"
          style="width: 236px"
          v-model:value="searchData.deviceUuid"
        >
          <a-select-option
            :value="item"
            :key="item"
            v-for="(item, i) in deviceList"
          >{{item}}</a-select-option>
        </a-select>
        <a-select
          v-else
          style="width: 236px"
          v-model:value="searchData.deviceUuid"
        >
          <a-select-option
            :value="item"
            :key="item"
            v-for="(item, i) in deviceLists"
          >{{item}}</a-select-option>
        </a-select>
        <a-divider type="vertical" />
      </a-col>
      <a-col class="ipt">
        <span>创建时间</span>
        <a-range-picker
          @change="rangePicker"
          showTime
        />
        <a-divider type="vertical" />
      </a-col>
      <a-col class="operate">
        <a-button
          type="primary"
          @click="search"
        >查询</a-button>
        <a-button
          type="default"
          @click="reset"
        >重置</a-button>
        <a-button
          type="primary"
          @click="addModalShow"
        >添加</a-button>
      </a-col>
    </a-row>
    <a-table
      rowKey="deviceUuid"
      :pagination="pagination"
      :columns="columns"
      :data-source="dataSource"
      @change="change"
    >
      <template #action="{record}">
        <a-button
          class="del"
          @click="delModalShow(record.deviceUuid)"
        >
          删除
        </a-button>
      </template>
    </a-table>
    <AddSet
      ref="addSet"
      @confirm="init"
    />
    <DelModal
      ref="DelModal"
      @confirm="confirmDel"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import _global from '@/utils/global'
import Header from "@/components/header/header.vue";
import AddSet from "@/components/datas/add.vue";
import { getDataReportRuleList, deleteReportRus, getDeviceId } from "@/api/warning/warning.js";
import DelModal from "@/components/delModal.vue";

export default {
  name: "DataReportSet",
  components: {
    Header,
    AddSet,
    DelModal
  },
  data() {
    return {
      baseURL: _global.baseURL,
      presentPage: '',
      siteId: 0,
      dataFrom: [
        {
          value: 0,
          siteId: '站内'
        }, {
          value: 1,
          siteId: '站外'
        }
      ],
      searchData: {
        deviceUuid: '',
        createStartTime: '',
        createEndTime: ''
      },
      query: {
        pageNum: 1,
        pageSize: 10
      },
      pagination: {
        size: 'small',
        showSizeChanger: true,
        showQuickJumper: true,
        pageSize: 10,
        showTotal: total => `共 ${total} 条`,
        total: 0
      },
      columns: [
        {
          title: '设备名称',
          dataIndex: 'deviceName',
        },
        {
          title: '设备UUID',
          dataIndex: 'deviceUuid',
        },
        {
          title: '时间规则',
          dataIndex: 'timeRule',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          dataIndex: 'action',
          slots: {
            customRender: 'action',
          }
        }
      ],
      dataSource: [],
      deviceList: [],
      deviceLists: []
    }
  },
  mounted() {
    this.presentPage = this.$route.query.name
    this.init()
    getDeviceId({ site: 0 }).then(res => { //站内
      if (res.code === 200) {
        this.deviceList = res.data
      }
    })
    getDeviceId({ site: 1 }).then(res => { //站外
      if (res.code === 200) {
        this.deviceLists = res.data
      }
    })
  },
  methods: {
    handleDataFrom(value) {
      // console.log(value)
      this.siteId = value
    },
    rangePicker(value, dateString) {
      // console.log(value, dateString)
      this.searchData.createStartTime = dateString[0]
      this.searchData.createEndTime = dateString[1]
    },
    search() {
      this.query.filterDate = this.searchData
      this.init()
    },
    reset() {
      this.searchData.deviceUuid = ''
      this.searchData.createStartTime = ''
      this.searchData.createEndTime = ''
      this.search()
    },
    init() {
      getDataReportRuleList(this.query).then(res => { //列表
        if (res.code == 200) {
          this.dataSource = res.data.list
          this.pagination.total = res.data.total
        }
      }).catch(res => {
        console.log(res)
      });
    },
    addModalShow() {
      if (this.siteId == 0) {
        this.uuidList = this.deviceList
      } else {
        this.uuidList = this.deviceLists
      }
      this.$refs.addSet.show(this.uuidList);
    },
    delModalShow(id) {
      var ids = []
      ids[0] = id
      this.delQuery = {
        ids: ids
      }
      this.$refs.DelModal.show();
    },
    confirmDel() {
      deleteReportRus(this.delQuery).then(res => {
        if (res.code == 200) {
          this.init()
          this.$message.success('删除成功');
        }
      }).catch(res => {
        console.log(res)
      })
    },
    change(pagination) {
      console.log(pagination)
      this.query = {
        pageNum: pagination.current,
        pageSize: pagination.pageSize
      }
      this.init()
    }
  }
};
</script>
<style scoped>
.top {
  height: 76px;
  padding: 20px 30px;
  line-height: 36px;
  background: #fff;
}

.ipt {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: left;
}
.ipt span {
  margin-right: 10px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #222;
}
.ipt input {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ant-divider-vertical {
  height: 22px;
  margin: 0 15px;
  background: #dddddd;
}
.ant-select :deep() .ant-select-selector {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ant-select :deep() .ant-select-selection-item {
  height: 34px;
  line-height: 34px;
}
.ipt :deep() .ant-calendar-picker {
  width: 236px;
}
.ipt :deep() .ant-calendar-picker-input {
  width: 100%;
  height: 36px;
  border-radius: 6px;
}
.operate {
  text-align: left;
}
.operate button:nth-child(1),
.operate button:nth-child(3) {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.operate button:nth-child(2) {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  background: #fff;
  border: 1px solid #bbbbbb;
  border-radius: 6px;
}
.add button {
  width: 80px;
  height: 36px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.ant-table-wrapper {
  margin: 0 30px;
}
.ant-table-wrapper :deep() .ant-table-thead > tr > th,
.ant-table-wrapper :deep() .ant-table table {
  text-align: center;
}
.ant-table-wrapper .ant-btn {
  width: 66px;
  height: 24px;
  padding: 0;
  margin: 0 5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  border-radius: 4px;
}
.alter {
  color: #0088ff;
  background: #fff;
  border: 1px solid #0088ff;
}
.del {
  color: #ff4444;
  background: #fff;
  border: 1px solid #ff4444;
}
.container :deep() .ant-tabs-bar {
  margin: 0 30px;
  text-align: left;
  background: #fff;
}
</style>
